import { render, staticRenderFns } from "./MonthsEstablishmentSettingsTable.vue?vue&type=template&id=20bd725e&"
import script from "./MonthsEstablishmentSettingsTable.vue?vue&type=script&lang=js&"
export * from "./MonthsEstablishmentSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports